import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=4aac9216&"
import script from "./InformacionGeneral.vue?vue&type=script&lang=ts&"
export * from "./InformacionGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4aac9216', component.options)
    } else {
      api.reload('4aac9216', component.options)
    }
    module.hot.accept("./InformacionGeneral.vue?vue&type=template&id=4aac9216&", function () {
      api.rerender('4aac9216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/RecepcionEquipos/Acciones/InformacionGeneral.vue"
export default component.exports